export enum IconBackgroundType {
    Transparent = 0,
    Rectangle = 1,
    Circle = 2,
    RoundedRectangle = 3,
}